import { Card, formatSchoolYear, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { ObjectiveReportsPostsecondaryAttainment } from "generated/openApi";

export const ObjectivePostsecondaryAttainment = (props: {
  title: string;
  objective: ObjectiveReportsPostsecondaryAttainment;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  return (
    <Card header={props.title}>
      <Grid ref={breakpointsRef} container spacing="lg" maxWidth="1000px">
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="lg">
            <Stack spacing="sm" justifyContent={"center"} alignItems="center">
              <Typography variant="body1" textAlign={"center"}>
                School Year
              </Typography>
              <Typography variant="h6">{formatSchoolYear(props.objective.schoolYear)}</Typography>
            </Stack>
            <Stack spacing="sm" justifyContent={"center"} alignItems="center">
              <Typography variant="body1" textAlign={"center"}>
                Participants
              </Typography>
              <Typography variant="h6">{props.objective.participants}</Typography>
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              GRADUATED within {props.objective.yearDiff} years
            </Typography>
            <Typography variant="h6">{props.objective.graduatedWithinXYears}</Typography>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Attainment %
            </Typography>
            <Typography variant="h6">{props.objective.attainmentPercent?.toFixed(2)}%</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};
